import * as themes from '../theming';
export function getPrimaryValues() {
    return Object.keys(themes).reduce((acc, theme) => (Object.assign(Object.assign({}, acc), { [theme]: `hsl(${themes[theme]['--primary']})` })), {});
}
